import React from "react";
import "./CarLoaderFull.scss";

const CarLoaderFull = ({textHeading,text,subtext}) => {
  return (
    <div className="fullCarMainFlx">
      <div className="fullCarAnimBg">
      <div className="fullCarBg">
       <div className="dataFetchTxtHeading">{textHeading}</div>
       <div className="dataFetchTxt">{text}</div>
       <div className="dataFetchSubTxt">{subtext}</div>
      </div>      
      </div>
    </div>
  );
};

export default CarLoaderFull;
